import { useTranslation } from '../../lib/i18n';
import {
  PRODUCT_DETAIL_LARGE_IMAGE_SIZE,
  WINE_DETAIL_LARGE_IMAGE_SIZE,
} from '../../lib/images';
import { useLightBox } from '../lightbox-context';
import ProductImage from '../product/image';
import { useProduct } from './product-context';

export const DefaultTitle = ({ product, className = '' }) => {
  const { attrT } = useTranslation();
  return (
    <h1
      className={`${className} text-black lg:text-left lg:text-6xl lg:text-varTitle`}
    >
      {attrT(product, 'name')}
    </h1>
  );
};

export const Hero = ({
  title,
  heroClassName,
  heroImageClassName,
  imageAlign = 'text-center',
  flyer,
}) => {
  const product = useProduct();

  // @ts-ignore
  const { setUrl } = useLightBox();

  const onImageClick = () => {
    if (product.images.length > 0) {
      setUrl(product.images[0].url);
    }
  };
  const Title = title;

  return (
    <>
      <div
        className={`mb-7 w-full bg-varBackground text-center lg:text-left ${
          product.type === 'wein' ? '' : 'detail-offset'
        }`}
      >
        <div className={`mx-auto max-w-6xl px-6 6xl:px-0 ${heroClassName}`}>
          <div className='flex items-center'>
            <Title
              product={product}
              className={`hidden  lg:block ${
                product.type === 'wein'
                  ? flyer
                    ? 'w-[100%]'
                    : 'w-8/12'
                  : 'w-1/2'
              }`}
            />
            <ProductImage
              align={imageAlign}
              className={`mb-[-6px] flex-grow`}
              heroImageClassName={heroImageClassName}
              product={product}
              size={
                product.type === 'wein'
                  ? WINE_DETAIL_LARGE_IMAGE_SIZE
                  : PRODUCT_DETAIL_LARGE_IMAGE_SIZE
              }
              onClick={onImageClick}
              preload={true}
            />
          </div>
        </div>
      </div>
      <Title product={product} className='mx-auto my-5 text-center lg:hidden' />
    </>
  );
};
